import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import renderIf from 'render-if';
import { Link } from 'react-router-dom';
import CustomButton from '../../../../components/CustomButton/CustomButton';
import styles from './UserInfo.scss';

const UserInfo = (props) => {
  const { deleteCoach, userInfo, id, userType } = props;
  const renderDeleteButton = renderIf(props.usedFor === 'DELETE COACH');
  const renderStudentDetails = renderIf(props.userType === 'STUDENT');
  return (
    <div className={userType === 'STUDENT' ? cn('col s12', styles.studentContainer) : cn('col s12', styles.container)}>
      <div className={cn('col s12 m8', styles.removePadding)}>
        <div className={styles.imageContainer}>
          <img className={styles.userIcon} src="https://media.dev.myrecruitboard.com/Images/defaultAthlete.png" alt="college-icon" />
        </div>
        <div className={styles.textContainer}>
          <span>{userInfo.name}</span> <br />
          <span>{userInfo.email}</span> <br />
        </div>
      </div>
      <div className={cn('col s12 m4', styles.deleteButtonContainer)}>
        <span>
          {renderDeleteButton(
            <CustomButton label="DELETE COACH" onClick={() => deleteCoach(id, userInfo.coach_id)} />,
          )}
        </span>
      </div>
      {renderStudentDetails(
        <div className={cn('col s12', styles.removePadding)}>
          <br />
          <span className={styles.header}>STUDENT BIOMETRICS</span><br />
          {userInfo.t40 !== undefined ? <span>40TIME: &nbsp;&nbsp;{userInfo.t40}</span> : ''} &nbsp;&nbsp;&nbsp;
          {userInfo.squats !== undefined ? <span>SQUATS: &nbsp;&nbsp;{userInfo.squats}</span> : ''} &nbsp;&nbsp;&nbsp;
          {userInfo.bench !== undefined ? <span>BENCH: &nbsp;&nbsp;{userInfo.bench}</span> : ''}&nbsp;&nbsp;&nbsp; <br /><br />
          <span className={styles.header}>POSITIONS</span><br />
          {userInfo.primaryOff !== undefined ?
            <span>Primary Offensive: &nbsp;&nbsp;{userInfo.primaryOff}</span> : ''}<br />
          {userInfo.primaryDef !== undefined ?
            <span>Primary Defensive: &nbsp;&nbsp;{userInfo.primaryDef}</span> : ''}<br />
          {userInfo.secondaryOff !== undefined ?
            <span>Secondary Offensive: &nbsp;&nbsp;{userInfo.secondaryOff}</span> : ''}&nbsp;&nbsp;&nbsp;
          {userInfo.secondaryDef !== undefined ?
            <span>Secondary Defensive: &nbsp;&nbsp;{userInfo.secondaryDef}</span> : ''}
          <br />
          <Link to={`/athlete/${userInfo.id}`} target="_blank">
            <br />
            <a>Go to his profile</a>
          </Link>
        </div>,
      )}
    </div>
  );
};

UserInfo.propTypes = {
  userInfo: PropTypes.shape.isRequired,
  usedFor: PropTypes.string,
  deleteCoach: PropTypes.func.isRequired,
  id: PropTypes.number,
  userType: PropTypes.string,
};

UserInfo.defaultProps = {
  usedFor: '',
  userType: '',
  id: '',
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/Userinfo/View.js